import React from 'react';
import AdvisoriesSummaryProps from '../interfaces/AdvisoriesSummaryProps';
import { Tooltip } from 'react-tooltip';
import AdvisoryComposer from './AdvisoryComposer';

const AdvisoriesSummaryComposer: React.FC<AdvisoriesSummaryProps> = ({ report }) => {

    return <ul>
        {Object.keys(report.advisories).map((packageName: string) => (
            <li key={packageName}>
                <strong>{packageName}</strong>
                {Array.isArray(report.advisories[packageName]) && <ul>
                    {report.advisories[packageName].map((advisory: any) => (
                        <li key={advisory.advisoryId}>
                            <a href={advisory.link} target="_blank" rel="noreferrer" data-tooltip-id={`tooltip-${advisory.advisoryId}`}>{advisory.title}</a>
                            <Tooltip
                                id={`tooltip-${advisory.advisoryId}`}
                                place="bottom"
                            >
                                <AdvisoryComposer
                                    packageName={advisory.title}
                                    advisory={advisory}
                                />
                            </Tooltip>
                        </li>
                    ))}
                </ul>}
                {!Array.isArray(report.advisories[packageName]) && <ul>
                    {Object.keys(report.advisories[packageName]).map((advisory: any) => (
                        <li key={report.advisories[packageName][advisory].advisoryId}>
                            <a href={report.advisories[packageName][advisory].link} target="_blank" rel="noreferrer" data-tooltip-id={`tooltip-${report.advisories[packageName][advisory].advisoryId}`}>{report.advisories[packageName][advisory].title}</a>
                            <Tooltip
                                id={`tooltip-${report.advisories[packageName][advisory].advisoryId}`}
                                place="bottom"
                            >
                                <AdvisoryComposer
                                    packageName={report.advisories[packageName][advisory].title}
                                    advisory={report.advisories[packageName][advisory]}
                                />
                            </Tooltip>
                        </li>
                    ))}
                </ul>}
            </li>
        ))}
        {Object.keys(report.advisories).length === 0 && (
            <div>
                <p>Aucun problème de sécurité détecté</p>
            </div>
        )}
    </ul>
}

export default AdvisoriesSummaryComposer;